/**
 * Where a session stands, as the admin's sessions screen and a campaign's
 * session scheduler say it (getSessionStatus): a pill in the lifecycle's tone,
 * its dot pulsing while the session is live. An interrupted session — running,
 * with no match on its world — is amber and still: its players' ways in refuse
 * it as interrupted, and only an administrator can start its match again
 * (Launch Match).
 */

import { useTranslation } from 'react-i18next';
import { Pill, type PillTone } from '../../components/pill';
import { sessionStatusTone } from './status-tone';
import type { SessionStatusView } from './session-status';

/** Each status's words, its tone, and whether it is live. */
const SESSION_STATUS_LOOK: Record<SessionStatusView, { key: string; tone: PillTone; live: boolean }> = {
  draft: { key: 'admin.sessions.status.draft', tone: sessionStatusTone('DRAFT'), live: false },
  scheduled: { key: 'admin.sessions.status.scheduled', tone: sessionStatusTone('SCHEDULED'), live: false },
  'in-progress': { key: 'admin.sessions.status.in-progress', tone: sessionStatusTone('RUNNING'), live: true },
  interrupted: { key: 'admin.sessions.status.interrupted', tone: 'warning', live: false },
  ended: { key: 'admin.sessions.status.ended', tone: sessionStatusTone('FINISHED'), live: false },
  cancelled: { key: 'admin.sessions.status.cancelled', tone: sessionStatusTone('CANCELLED'), live: false },
};

export function SessionStatusPill({ status }: { status: SessionStatusView }) {
  const { t } = useTranslation();
  const look = SESSION_STATUS_LOOK[status];
  return (
    <Pill tone={look.tone} dot pulsing={look.live}>
      {t(look.key)}
    </Pill>
  );
}
